import { CreditDebitNoteEtaxFields, NoteStatus } from "../../types/credit-debit-note.type";

export type NoteEtaxSource = CreditDebitNoteEtaxFields & { status: NoteStatus };

/**
 * Whether there is an e-Tax state to show for the note. An issued note has one whenever the
 * backend says where it goes; a cancelled note only while its document is still out, because
 * "ค้างส่ง" on a cancelled note would claim it is still owed.
 */
export const hasNoteEtaxState = (note: NoteEtaxSource): boolean => {
  if (note.etax_enabled === undefined) return false;
  if (note.status === "ISSUED") return true;
  return note.etax_status === "IN_PROGRESS" || note.etax_status === "COMPLETED";
};
